import { render, staticRenderFns } from "./ListBookingPage.vue?vue&type=template&id=2a430805"
import script from "./ListBookingPage.vue?vue&type=script&lang=js"
export * from "./ListBookingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports